module.exports = __webpack_public_path__ + "img/icon_map_zngg.76b41dd7.png";